exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TeltsYh1Ai1RtTT4Y3pFu{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3btR5Ul4KokPKhUvtqSAI2{width:39px;height:39px}", ""]);
// Exports
exports.locals = {
	"spinnerContainer": "TeltsYh1Ai1RtTT4Y3pFu",
	"spinner": "_3btR5Ul4KokPKhUvtqSAI2"
};